import React, { useState } from 'react'

import { BillPay as BillPayIcon } from 'components/Icons'
import { SegmentGroup } from 'components/Common'
import { BillPayModal } from './BillPayModal'

export const BillPay = () => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <SegmentGroup
        icon={<BillPayIcon width={30} height={30} />}
        title='Bill Pay'
        description='Pay your medical bills online'
        triggerText={'View ›'}
        onClickTrigger={() => setOpen(true)}
      />
      {open && (
        <BillPayModal
          open={open}
          setOpen={setOpen}
        />
      )}
    </>
  )
}
